// old 

import { configureStore } from "@reduxjs/toolkit";
import CountryReducer from "./Slices/countrySlice";
import VoucherDetail from "./Slices/VoucherDetail";

const store = configureStore({
  reducer: {
    Country: CountryReducer,
    voucherDetailSlice:VoucherDetail
  },
});

export { store };


// presist for now off 
// import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import storage from "redux-persist/lib/storage";
// import { persistReducer, persistStore } from "redux-persist";
// import CountryReducer from "./Slices/countrySlice";
// import VoucherDetail from "./Slices/VoucherDetail";

// const persistConfig = {
//   key: "root",
//   storage,
// };

// // Combine Reducers
// const rootReducer = combineReducers({
//   Country: CountryReducer,
//   voucherDetailSlice: VoucherDetail,
// });

// // Apply Persist Reducer
// const persistedReducer = persistReducer(persistConfig, rootReducer);

// // Create Store
// const store = configureStore({
//   reducer: persistedReducer,
// });

// // Create Persistor
// const persistor = persistStore(store);

// export { store, persistor };
